import type {
	ICellValue,
	InternalState,
	INumberField,
	INumberFieldProperty,
} from '../types'

import z from 'zod'

import { getFieldDefaultProperty } from '../constants'
import { numberToShow } from '../number'
import { str2Currency } from '../string'
import { FieldType } from '../types'
import { NumberBaseField } from './number-base-field'

export class NumberField extends NumberBaseField {
	constructor(
		public override field: INumberField,
		public override state: InternalState
	) {
		super(field, state)
	}

	static readonly propertySchema = z.object({
		precision: z.number().min(0).max(1000),
		defaultValue: z.string().optional(),
		commaStyle: z.string().optional(),
		symbol: z.string().optional(),
	})

	override cellValueToString(cellValue: ICellValue): string | null {
		if (this.validate(cellValue)) {
			const { symbol, precision, commaStyle } = this.field.property
			const cellString = numberToShow(cellValue, precision)

			if (!symbol && !commaStyle) {
				return cellString
			}
			if (!commaStyle) {
				return `${cellString}${symbol}`
			}

			return str2Currency(cellString, symbol, 3, commaStyle)
		}

		return null
	}
	static defaultProperty() {
		return getFieldDefaultProperty(FieldType.Number) as INumberFieldProperty
	}
}
